import { getUser } from "../../service/AccountService";
import { RolesEnum, CompanyTypesEnum } from "../../utils/Enums";

const menus = [
  {
    url: "/",
    icon: "apps",
    text: "Ordens de Serviço",
    roles: [
      RolesEnum.BackOffice,
      RolesEnum.Manager,
      RolesEnum.Operator,
      RolesEnum.Technician
    ],
    companyTypes: [
      CompanyTypesEnum.Tranpo,
      CompanyTypesEnum.Benefited,
      CompanyTypesEnum.Contractor,
      CompanyTypesEnum.Hired
    ]
  },
  {
    url: "/companies",
    icon: "supervisor_account",
    text: "Clientes",
    roles: [RolesEnum.BackOffice, RolesEnum.Manager],
    companyTypes: [CompanyTypesEnum.Tranpo]
  },
  {
    url: "/company/profile/:companyId",
    icon: "store",
    text: "Configurações",
    roles: [RolesEnum.Manager],
    companyTypes: [CompanyTypesEnum.Contractor, CompanyTypesEnum.Hired]
  },
  {
    url: "/invoices",
    icon: "payment",
    text: "Faturas",
    roles: [RolesEnum.BackOffice, RolesEnum.Manager, RolesEnum.Operator],
    companyTypes: [
      CompanyTypesEnum.Tranpo,
      CompanyTypesEnum.Hired,
      CompanyTypesEnum.Contractor
    ]
  },
  {
    url: `/customers/:companyId`,
    icon: "supervisor_account",
    text: "Clientes",
    roles: [RolesEnum.Manager, RolesEnum.Operator],
    companyTypes: [CompanyTypesEnum.Contractor]
  },
  {
    url: "/reports",
    icon: "assignment",
    text: "Relatórios",
    roles: [RolesEnum.BackOffice, RolesEnum.Manager],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor]
  },
  {
    url: "/budgets",
    icon: "monetization_on",
    text: "Orçamentos",
    roles: [RolesEnum.BackOffice, RolesEnum.Manager],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor]
  }
];

export default () => {
  const { role, cid, type } = getUser();
  return menus
    .filter(menu => menu.roles.some(r => r === role))
    .filter(menu => menu.companyTypes.some(t => t === type))
    .map(menu => {
      menu.url = menu.url.replace(":companyId", cid);
      return menu;
    });
};



// WEBPACK FOOTER //
// ./src/shared/infra/menus/Menus.js